import { SELF_PROFILE_HREF } from "@magnus/contract/profile";

/**
 * Settings live in the viewer's own profile, under its Customization tab
 * (`/profiles/me` is whoever is viewing). `/settings/*` still redirects
 * here, but in-app links go direct.
 */
export const SETTINGS_HREF = `${SELF_PROFILE_HREF}/customization`;

export type SettingsSection =
  | "notifications"
  | "memory"
  | "connectors"
  | "permissions";

export function settingsHref(section?: SettingsSection): string {
  return section ? `${SETTINGS_HREF}/${section}` : SETTINGS_HREF;
}
